import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { DocumentListingParams, DocumentListingResponse } from 'model/DocumentListing';
import { withLanguageRewrite } from '@/store/handleRequestLanguage';
import { apiGateway } from 'api/apiHost';

const customBaseQuery = fetchBaseQuery({
  baseUrl: apiGateway.proxyPath,
});

// Define a service using a base URL and expected endpoints
export const documentListingAPI = createApi({
  reducerPath: 'documentListingApi',
  baseQuery: withLanguageRewrite(customBaseQuery),
  endpoints: (build) => ({
    getDocuments: build.query<DocumentListingResponse, DocumentListingParams>({
      query: (body) => ({
        url: '/library/documentListing',
        method: 'POST',
        body: body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDocumentsQuery } = documentListingAPI;
